// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/BebasNeue Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Lato-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Lato-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/BebasNeue-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------fonts----------------*/

body {
  margin: 0;
}

@font-face {
  font-family: 'Bebas-Book';
  src:url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

@font-face {
  font-family: 'Lato-Ragular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'Lato-Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: 'Lato-Thin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: 'BebasNeue-Ragular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}


@font-face {
  font-family: 'BebasNeue-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: 'Lato-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

/*------css-------*/


li {
    list-style-type: disc;
    list-style-position: inside;
    padding: 10px 0 10px 0;
    text-indent: -1.5em;
}

.header_main_sec {
  justify-content: space-between;
  background-color: #31B89D;
  margin-top: 0;
  margin-bottom: 0;
  height: 100%;

}

.inner_main_sec {
  justify-content: space-between;
  margin-bottom: 8rem;
  padding-top: 5rem;
  padding-right: 4rem;
  padding-left:4rem

}
.header_sec{
  font-family: BebasNeue-Ragular;
  font-size: 3.5rem;
  color:#ffffff;
  text-align: left;
}

.header_body_sec {
  text-align: justify;
  font-size: 1.1rem;
  font-family: Lato-Light;
  color:#ffffff;
  font-weight: 500;
  width: 50%;
}

#banner_divider_sec {
  display: flex;
  align-items: center;
  max-width: 40%;
}

#banner_divider {
  background-color: #ffffff;
  height: 2px;
  margin-bottom: 10px;
}

.banner_pattern {
  width:100%
}

.scroll_sec {
  font-family: Lato-Ragular;
  font-size: 1.5rem;
  color:#ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.secondary_header_sec {
  font-family: Lato-Bold;
  font-size: 2rem;
  text-align: justify;
  font-weight: 1200;
  color: #FF9700;
  margin-left: 10px;

}

.accordion_header_sec {
  font-family: Lato-Bold;
  font-size: 1.7rem;
  text-align: justify;
  font-weight: 400;
  color:#31B89D;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.font-Lato-regular-500 {
  font-family: Lato-Ragular;
  font-size: 1.1rem;
  color:#000000;
  font-weight: 400;
  text-align: justify;
}


.box_header_sec {
  font-family: Lato-Ragular;
  font-size: 1.3rem;
  color:#000000;
  margin-bottom:10px;
  font-weight: 400;
  text-align: left;
}

.logo-image {
  width: 100px;
  height: 100px;
  filter: brightness(0) invert(1);
}

.banner-pattern{
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.heading_logo {
  height: 100px;
  width: 100px;
  margin-right: 60px;
}

.box_body_sec {
  font-family: Lato-Light;
  color:#000000;
  line-height: 1.5;
  font-weight: 300;
  font-size: 1.1rem;
  text-align: justify;
}

.button_footer_sec{
  font-family: Lato-Regular;
  color:#000000;
  line-height: 1.25rem;
  font-weight: 500;
  text-align: justify;
}

.audience_sec {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

.button_sec_of_card {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.learnMoreButton:hover{
  cursor: pointer;
}

.downloadToolButton:hover {
  cursor: pointer;
}

.learnMoreButton {
    color: #000000;
    font-weight: 300;
    pointer-events: 'all';
    border: 2px solid #31B89D;
    height: 2.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Lato-Light;
    text-align: justify;
    font-size: 1rem;
}

.downloadToolButton {
  color:#ffffff;
  font-weight:300;
  pointer-events:'all';
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #31B89D;
  font-family: Lato-Light;
  text-align: justify;
  font-size: 1rem;
  
}
.age_span {
  font-size: 2rem;
  font-family: Lato-Ragular;
  color: #000000;
  text-align: justify;
}


.footer_sec {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #31B89D;
  margin-top: 4rem;
  font-family: Lato-Bold;
  color: #ffffff;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: justify;
}
/* <------- media queries-------> */




@media (max-width: 431px) {

  .inner_main_sec {
    margin-bottom: 15px;
    padding-right: 2rem;
    padding-left: 2rem;
  }

  .header_sec {
    font-size: 2.2rem;
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    text-align: justify;

  }

  .logo-image {
    width: 60px;
    height: 60px;
  }

  #banner_divider_sec {
    max-width: 20%;
    /* margin-left: 6rem; */
  }
  .header_body_sec {
    font-size: 1rem;
   text-align: left;
   width: 100%;
   margin-bottom: 4rem;
   margin-top: 1rem;
  }

  .heading_logo {
    margin-right: 0;
    position: relative;
    height: 3rem;
    width: 3rem;
    bottom: 0.8rem;
    right: 0.5rem;
  }

  .banner_pattern {
    display: none;
  }
  .box_body_sec {
    position: relative;
    right:3rem;
    top:1rem
  }
  #banner_heading {
    flex-direction: column-reverse;
    align-items: baseline !important;
  }

.limit_sec {
  text-align: left;
}

.age_group_sec {
  display: flex;
  flex-direction: column;
}
.students_sec {
  text-align: left;
  line-height: 1.5;
  margin-top: 10px;
}
  .audience_sec {
    margin-top: 4rem !important;
  }

  .action_bottoms_sec {
    margin-top: 4rem !important;
  }

  .learnMoreButton {
    font-size: 0.8rem;
  }

  .downloadToolButton {
    font-size: 0.8rem;
  }

  .scroll_sec {
    font-size: 1rem;
    padding-top: 4rem !important;
  } 

}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,2BAA2B;EAC3B,4CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,4CAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,4CAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,4CAAgD;AAClD;;;AAGA;EACE,6BAA6B;EAC7B,4CAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,4CAAwC;AAC1C;;AAEA,mBAAmB;;;AAGnB;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB;;AAEF;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;AAEjB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;AACA,mCAAmC;;;;;AAKnC;;EAEE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;;EAErB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,eAAe;GAChB,gBAAgB;GAChB,WAAW;GACX,mBAAmB;GACnB,gBAAgB;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;IACV;EACF;EACA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;AAEF","sourcesContent":["/*--------------fonts----------------*/\n\nbody {\n  margin: 0;\n}\n\n@font-face {\n  font-family: 'Bebas-Book';\n  src:url('./assets/fonts/BebasNeue\\ Book.otf')\n}\n\n@font-face {\n  font-family: 'Lato-Ragular';\n  src: url('./assets/fonts/Lato-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'Lato-Light';\n  src: url('./assets/fonts/Lato-Light.ttf');\n}\n\n@font-face {\n  font-family: 'Lato-Thin';\n  src: url('./assets/fonts/Lato-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'BebasNeue-Ragular';\n  src: url('./assets/fonts/BebasNeue-Regular.ttf');\n}\n\n\n@font-face {\n  font-family: 'BebasNeue-Bold';\n  src: url('./assets/fonts/BebasNeue-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'Lato-Bold';\n  src: url('./assets/fonts/Lato-Bold.ttf');\n}\n\n/*------css-------*/\n\n\nli {\n    list-style-type: disc;\n    list-style-position: inside;\n    padding: 10px 0 10px 0;\n    text-indent: -1.5em;\n}\n\n.header_main_sec {\n  justify-content: space-between;\n  background-color: #31B89D;\n  margin-top: 0;\n  margin-bottom: 0;\n  height: 100%;\n\n}\n\n.inner_main_sec {\n  justify-content: space-between;\n  margin-bottom: 8rem;\n  padding-top: 5rem;\n  padding-right: 4rem;\n  padding-left:4rem\n\n}\n.header_sec{\n  font-family: BebasNeue-Ragular;\n  font-size: 3.5rem;\n  color:#ffffff;\n  text-align: left;\n}\n\n.header_body_sec {\n  text-align: justify;\n  font-size: 1.1rem;\n  font-family: Lato-Light;\n  color:#ffffff;\n  font-weight: 500;\n  width: 50%;\n}\n\n#banner_divider_sec {\n  display: flex;\n  align-items: center;\n  max-width: 40%;\n}\n\n#banner_divider {\n  background-color: #ffffff;\n  height: 2px;\n  margin-bottom: 10px;\n}\n\n.banner_pattern {\n  width:100%\n}\n\n.scroll_sec {\n  font-family: Lato-Ragular;\n  font-size: 1.5rem;\n  color:#ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.secondary_header_sec {\n  font-family: Lato-Bold;\n  font-size: 2rem;\n  text-align: justify;\n  font-weight: 1200;\n  color: #FF9700;\n  margin-left: 10px;\n\n}\n\n.accordion_header_sec {\n  font-family: Lato-Bold;\n  font-size: 1.7rem;\n  text-align: justify;\n  font-weight: 400;\n  color:#31B89D;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.font-Lato-regular-500 {\n  font-family: Lato-Ragular;\n  font-size: 1.1rem;\n  color:#000000;\n  font-weight: 400;\n  text-align: justify;\n}\n\n\n.box_header_sec {\n  font-family: Lato-Ragular;\n  font-size: 1.3rem;\n  color:#000000;\n  margin-bottom:10px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.logo-image {\n  width: 100px;\n  height: 100px;\n  filter: brightness(0) invert(1);\n}\n\n.banner-pattern{\n  width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n.heading_logo {\n  height: 100px;\n  width: 100px;\n  margin-right: 60px;\n}\n\n.box_body_sec {\n  font-family: Lato-Light;\n  color:#000000;\n  line-height: 1.5;\n  font-weight: 300;\n  font-size: 1.1rem;\n  text-align: justify;\n}\n\n.button_footer_sec{\n  font-family: Lato-Regular;\n  color:#000000;\n  line-height: 1.25rem;\n  font-weight: 500;\n  text-align: justify;\n}\n\n.audience_sec {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: space-between !important;\n}\n\n.button_sec_of_card {\n  margin-top: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n\n.learnMoreButton:hover{\n  cursor: pointer;\n}\n\n.downloadToolButton:hover {\n  cursor: pointer;\n}\n\n.learnMoreButton {\n    color: #000000;\n    font-weight: 300;\n    pointer-events: 'all';\n    border: 2px solid #31B89D;\n    height: 2.3rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: Lato-Light;\n    text-align: justify;\n    font-size: 1rem;\n}\n\n.downloadToolButton {\n  color:#ffffff;\n  font-weight:300;\n  pointer-events:'all';\n  height: 2.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #31B89D;\n  font-family: Lato-Light;\n  text-align: justify;\n  font-size: 1rem;\n  \n}\n.age_span {\n  font-size: 2rem;\n  font-family: Lato-Ragular;\n  color: #000000;\n  text-align: justify;\n}\n\n\n.footer_sec {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #31B89D;\n  margin-top: 4rem;\n  font-family: Lato-Bold;\n  color: #ffffff;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  text-align: justify;\n}\n/* <------- media queries-------> */\n\n\n\n\n@media (max-width: 431px) {\n\n  .inner_main_sec {\n    margin-bottom: 15px;\n    padding-right: 2rem;\n    padding-left: 2rem;\n  }\n\n  .header_sec {\n    font-size: 2.2rem;\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n    text-align: justify;\n\n  }\n\n  .logo-image {\n    width: 60px;\n    height: 60px;\n  }\n\n  #banner_divider_sec {\n    max-width: 20%;\n    /* margin-left: 6rem; */\n  }\n  .header_body_sec {\n    font-size: 1rem;\n   text-align: left;\n   width: 100%;\n   margin-bottom: 4rem;\n   margin-top: 1rem;\n  }\n\n  .heading_logo {\n    margin-right: 0;\n    position: relative;\n    height: 3rem;\n    width: 3rem;\n    bottom: 0.8rem;\n    right: 0.5rem;\n  }\n\n  .banner_pattern {\n    display: none;\n  }\n  .box_body_sec {\n    position: relative;\n    right:3rem;\n    top:1rem\n  }\n  #banner_heading {\n    flex-direction: column-reverse;\n    align-items: baseline !important;\n  }\n\n.limit_sec {\n  text-align: left;\n}\n\n.age_group_sec {\n  display: flex;\n  flex-direction: column;\n}\n.students_sec {\n  text-align: left;\n  line-height: 1.5;\n  margin-top: 10px;\n}\n  .audience_sec {\n    margin-top: 4rem !important;\n  }\n\n  .action_bottoms_sec {\n    margin-top: 4rem !important;\n  }\n\n  .learnMoreButton {\n    font-size: 0.8rem;\n  }\n\n  .downloadToolButton {\n    font-size: 0.8rem;\n  }\n\n  .scroll_sec {\n    font-size: 1rem;\n    padding-top: 4rem !important;\n  } \n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
